import { render, staticRenderFns } from "./html/ProductVariations.html?vue&type=template&id=2b27c5d8&lang=html&external"
import script from "./js/ProductVariations.js?vue&type=script&lang=js&external"
export * from "./js/ProductVariations.js?vue&type=script&lang=js&external"
import style0 from "./scss/ProductVariations.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports